import { INPUT_TUNING } from "../config/input.ts";
import { wrapRadians } from "../core/math.ts";

export function applyPointerDeltaToYaw(
  currentYaw: number,
  movementX: number,
  radiansPerPixel = INPUT_TUNING.pointerYawRadiansPerPixel,
): number {
  return wrapRadians(currentYaw - movementX * radiansPerPixel);
}

export class PointerInputAdapter {
  #yaw = 0;

  constructor(initialYaw = 0) {
    this.#yaw = wrapRadians(initialYaw);
  }

  rotateByPixels(movementX: number): void {
    this.#yaw = applyPointerDeltaToYaw(this.#yaw, movementX);
  }

  resetYaw(yaw: number): void {
    this.#yaw = wrapRadians(yaw);
  }

  sampleYaw(): number {
    return this.#yaw;
  }
}
